

// import React, { useEffect, useState } from 'react';
// import axios from 'axios';
// import { Box, Typography } from '@mui/material';
// import TableComponent from '../../Components/TableComponent/TableComponent';
// import { SnackBarComponent } from '../../Components/snackBar/snackBar';
// import { API_BASE_URL } from '../../config';
// import { LoadingSpinner } from '../../Components/spinner/spinner';

// export const StaffAsset52Component = () => {
//   const [rows, setRows] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [snackbarOpen, setSnackbarOpen] = useState(false);
//   const [snackbarMessage, setSnackbarMessage] = useState('');
//   const [snackbarSeverity, setSnackbarSeverity] = useState('info');

//   const columns = [
//     { id: 'slNo', field: 'slNo', headerName: 'Sl. No', width: 70 },

//     // Fields from assigned FE through nested serializers
//     { id: 'name_of_fe', field: 'name_of_fe', headerName: 'Financial Establishment', width: 250 },
//     { id: 'name_of_ca', field: 'name_of_ca', headerName: 'Competent Authority', width: 200 },

//     // Related asset3_2_base notification info
//     { id: 'notification', field: 'notification', headerName: 'Notification', width: 150 },
//     { id: 'date', field: 'date', headerName: '3(2) Date', width: 120 },
//     { id: 'notification_no', field: 'notification_no', headerName: 'Notification No', width: 150 },

//     // From AssetPropertyDetails
//     { id: 'property_detals', field: 'property_detals', headerName: 'Property Details', width: 200 },
//     { id: 'survey_no', field: 'survey_no', headerName: 'Survey No', width: 120 },
//     { id: 'property_type', field: 'property_type', headerName: 'Property Type', width: 150 },

//     // From Asset_5_2 model
//     { id: 'misc', field: 'misc', headerName: 'Misc', width: 150 },
//     { id: 'orderDate', field: 'misc', headerName: '5(2) Order Date', width: 150 },
//     { id: 'court_order', field: 'court_order', headerName: 'Court Order', width: 250 },
//     { id: 'result', field: 'result', headerName: 'Result', width: 250 },
//     { id: 'appeals', field: 'appeals', headerName: 'Appeals', width: 250 },
//   ];

//   useEffect(() => {
//     axios
//       .get(`${API_BASE_URL}/asset-mgmt/asset52/`)  
//       .then((response) => {
//         const apiData = response.data.map((item, index) => ({
//           id: item.id || index,
//           slNo: index + 1,
//           name_of_fe: item.asset_property_base?.asset3_2_base?.fe?.name_of_fe || '-',
//           name_of_ca: item.asset_property_base?.asset3_2_base?.fe?.name_of_ca || '-',
//           notification: item.asset_property_base?.asset3_2_base?.notification || '-',
//           date: item.asset_property_base?.asset3_2_base?.date
//             ? new Date(item.asset_property_base.asset3_2_base.date).toLocaleDateString('en-GB').replace(/\//g, '-')
//             : '-',
//           notification_no: item.asset_property_base?.asset3_2_base?.notification_no || '-',
//           property_detals: item.asset_property_base?.property_detals || '-',
//           survey_no: item.asset_property_base?.survey_no || '-',
//           property_type: item.asset_property_base?.property_type || '-',
//           misc: item.misc || '-',
//           court_order: item.court_order || '-',
//           result: item.result || '-',
//           appeals: item.appeals || '-',
//         }));

//         setRows(apiData);
//         setSnackbarMessage('Asset 5(2) data loaded successfully.');
//         setSnackbarSeverity('success');
//         setSnackbarOpen(true);
//         setLoading(false);
//       })
//       .catch((error) => {
//         console.error('Failed to fetch Asset 5(2) data:', error);
//         setSnackbarMessage('Failed to load Asset 5(2) data.');
//         setSnackbarSeverity('error');
//         setSnackbarOpen(true);
//         setLoading(false);
//       });
//   }, []);

//   const handleSnackbarClose = () => {
//     setSnackbarOpen(false);
//   };

//   if (loading) {
//     return <LoadingSpinner size={30} />;
//   }

//   return (
//     <Box
//       sx={{
//         width: '100%',
//         mt: 8,
//         mb: 1,
//         borderRadius: 2,
//         boxShadow: '0 4px 12px rgba(0, 0, 0, 0.1)',
//         backgroundColor: '#fff',
//       }}
//     >
//       <Box display="flex" justifyContent="center" backgroundColor="rgba(195, 234, 203, 0.1)" mb={2}>
//         <Typography variant="h4" component="h1" align="center" sx={{ fontWeight: 'bold' }}>
//           Asset 5(2)
//         </Typography>
//       </Box>

//       <TableComponent
//         columns={columns}
//         rows={rows}
//         manageColumnStatus
//         enableSort={true}
//         sx={{
//           '& .MuiDataGrid-columnHeaders': {
//             backgroundColor: '#1976d2',
//             color: '#fff',
//             fontWeight: 'bold',
//           },
//         }}
//       />

//       <SnackBarComponent
//         open={snackbarOpen}
//         message={snackbarMessage}
//         severity={snackbarSeverity}
//         onClose={handleSnackbarClose}
//       />
//     </Box>
//   );
// };


import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Box, Typography } from '@mui/material';
import TableComponent from '../../Components/TableComponent/TableComponent';
import { SnackBarComponent } from '../../Components/snackBar/snackBar';
import { API_BASE_URL } from '../../config';
import { LoadingSpinner } from '../../Components/spinner/spinner';

export const StaffAsset52Component = () => {
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState('');
  const [snackbarSeverity, setSnackbarSeverity] = useState('info');

  const columns = [
    { id: 'slNo', field: 'slNo', headerName: 'Sl. No', width: 70 },

    { id: 'name_of_fe', field: 'name_of_fe', headerName: 'Financial Establishment', width: 250 },
    { id: 'name_of_ca', field: 'name_of_ca', headerName: 'Competent Authority', width: 200 },

    {
      id: 'notification',
      field: 'notification',
      headerName: 'Notification',
      width: 150,
      renderCell: (params) =>
        params.value && params.value !== '-' ? (
          <a
            href={params.value}
            target="_blank"
            rel="noopener noreferrer"
            style={{ color: '#1976d2', textDecoration: 'none', fontWeight: 500 }}
          >
            View
          </a>
        ) : (
          <span>-</span>
        ),
    },
    { id: 'date', field: 'date', headerName: '3(2) Date', width: 120 },
    { id: 'notification_no', field: 'notification_no', headerName: 'Notification No', width: 150 },

    { id: 'property_detals', field: 'property_detals', headerName: 'Property Details', width: 200 },
    { id: 'survey_no', field: 'survey_no', headerName: 'Survey No', width: 120 },
    { id: 'property_type', field: 'property_type', headerName: 'Property Type', width: 150 },

    { id: 'misc', field: 'misc', headerName: 'Misc', width: 150 },
    {
      id: 'orderDate',
      field: 'orderDate',
      headerName: '5(2) Order Date',
      width: 150,
    },
    {
      id: 'court_order',
      field: 'court_order',
      headerName: 'Court Order',
      width: 250,
      renderCell: (params) =>
        params.value && params.value !== '-' ? (
          <a
            href={params.value}
            target="_blank"
            rel="noopener noreferrer"
            style={{ color: '#1976d2', textDecoration: 'none', fontWeight: 500 }}
          >
            View
          </a>
        ) : (
          <span>-</span>
        ),
    },
    { id: 'result', field: 'result', headerName: 'Result', width: 250 },
    { id: 'appeals', field: 'appeals', headerName: 'Appeals', width: 250 },
  ];

  useEffect(() => {
    axios
      .get(`${API_BASE_URL}/asset-mgmt/asset52/`)
      .then((response) => {
        const apiData = response.data.map((item, index) => ({
          id: item.id || index,
          slNo: index + 1,
          name_of_fe: item.asset_property_base?.asset3_2_base?.fe?.name_of_fe || '-',
          name_of_ca: item.asset_property_base?.asset3_2_base?.fe?.name_of_ca || '-',
          notification: item.asset_property_base?.asset3_2_base?.notification|| '-', // link for notification
          date: item.asset_property_base?.asset3_2_base?.date
            ? new Date(item.asset_property_base.asset3_2_base.date).toLocaleDateString('en-GB').replace(/\//g, '-')
            : '-',
          notification_no: item.asset_property_base?.asset3_2_base?.notification_no || '-',
          property_detals: item.asset_property_base?.property_detals || '-',
          survey_no: item.asset_property_base?.survey_no || '-',
          property_type: item.asset_property_base?.property_type || '-',
          misc: item.misc || '-',
          orderDate: item.date || '-', 
          court_order: item.court_order || '-', // prefer link if available
          result: item.result || '-',
          appeals: item.appeals || '-',
        }));

        setRows(apiData);
        setSnackbarMessage('Asset 5(2) data loaded successfully.');
        setSnackbarSeverity('success');
        setSnackbarOpen(true);
        setLoading(false);
      })
      .catch((error) => {
        console.error('Failed to fetch Asset 5(2) data:', error);
        setSnackbarMessage('Failed to load Asset 5(2) data.');
        setSnackbarSeverity('error');
        setSnackbarOpen(true);
        setLoading(false);
      });
  }, []);

  const handleSnackbarClose = () => {
    setSnackbarOpen(false);
  };

  if (loading) {
    return <LoadingSpinner size={30} />;
  }

  return (
    <Box
      sx={{
        width: '100%',
        mt: 8,
        mb: 1,
        borderRadius: 2,
        boxShadow: '0 4px 12px rgba(0, 0, 0, 0.1)',
        backgroundColor: '#fff',
      }}
    >
      <Box display="flex" justifyContent="center" backgroundColor="rgba(195, 234, 203, 0.1)" mb={2}>
        <Typography variant="h4" component="h1" align="center" sx={{ fontWeight: 'bold' }}>
          Asset 5(2)
        </Typography>
      </Box>

      <TableComponent
        columns={columns}
        rows={rows}
        manageColumnStatus
        enableSort={true}
        sx={{
          '& .MuiDataGrid-columnHeaders': {
            backgroundColor: '#1976d2',
            color: '#fff',
            fontWeight: 'bold',
          },
        }}
      />

      <SnackBarComponent
        open={snackbarOpen}
        message={snackbarMessage}
        severity={snackbarSeverity}
        onClose={handleSnackbarClose}
      />
    </Box>
  );
};
